import { useQuery } from '@tanstack/react-query';
import type { JsonValue } from 'type-fest';

import {
  type ImportableItemDetailsBaseData,
  type PartData,
  queryClient,
  useRequest,
  type QueryFunction,
} from '@frontend/api';

type GetPartSearchResultDetailParams = {
  uuid: string;
};

export type PartSearchResultDetailData = {
  part: PartData;
  partMasterUuid: string;
  latestComponent: ImportableItemDetailsBaseData | null;
};

export const getUsePartSearchResultDetailKey = (
  params: GetPartSearchResultDetailParams,
) => ['similarParts', 'detail', params.uuid];

export const usePartSearchResultDetail: QueryFunction<
  PartSearchResultDetailData,
  [GetPartSearchResultDetailParams],
  ReturnType<typeof getUsePartSearchResultDetailKey>
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getUsePartSearchResultDetailKey(params),
    queryFn: ({ signal }) =>
      request<PartSearchResultDetailData & JsonValue>(
        `/similar_parts/detail/${params.uuid}`,
        {
          init: {
            method: 'GET',
            signal,
          },
        },
      ),
  });
};

export const invalidatePartSearchResultDetailQuery = (
  params: GetPartSearchResultDetailParams,
) => {
  queryClient.invalidateQueries({
    queryKey: getUsePartSearchResultDetailKey(params),
  });
};
